import { Injectable } from '@angular/core';

function escapeHtml(text: string): string {
  return text.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;');
}

@Injectable({
  providedIn: 'root',
})
export class LogService {
  formatLogLineRaw(rawLine: string): string {
    // eslint-disable-next-line no-control-regex
    const ansiPattern = new RegExp('\\u001b\\[(\\d+(?:;\\d+)*)m(.*?)\\u001b\\[0m', 'g');

    // La ligne vient de l'équipement et finit en [innerHTML] : on échappe TOUT avant d'ajouter nos
    // propres <span> (seuls balisages produits ici). Les séquences ANSI ne contiennent aucun
    // caractère échappé, elles restent reconnues.
    let line = escapeHtml(rawLine).replace(ansiPattern, (match, codes, text) => {
      const codeArr = codes.split(';').map(Number);
      const colorCode = codeArr[0];
      const isBright = codeArr.includes(1);
      let cssColor = '#ffffff';

      switch (colorCode) {
        case 31:
          cssColor = isBright ? '#ff4c4c' : '#ff0000';
          break;
        case 32:
          cssColor = isBright ? '#4caf50' : '#00ff00';
          break;
        case 33:
          cssColor = isBright ? '#ffff00' : '#cccc00';
          break;
        case 34:
          cssColor = isBright ? '#00bcd4' : '#0000ff';
          break;
        case 35:
          cssColor = isBright ? '#ff00ff' : '#cc00cc';
          break;
        case 36:
          cssColor = '#00ffff';
          break;
        case 37:
          cssColor = isBright ? '#ffffff' : '#dddddd';
          break;
        default:
          cssColor = '#ffffff';
      }
      return `<span style="color: ${cssColor} !important;">${text}</span>`;
    });

    // Wrap timestamps with a <span> for styling.
    line = line.replace(/\[(\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2})\]/g, '<span class="timestamp">[$1]</span>');
    // Wrap bracketed numbers with a <span>.
    line = line.replace(/\[(\s*\d+)\]/g, '<span class="brackets">[$1]</span>');

    return line;
  }

  /**
   * Removes HTML tags from a string.
   * @param html The HTML string to strip.
   * @returns Plain text without HTML tags.
   */
  stripHtml(html: string): string {
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = html;
    return tempDiv.textContent || tempDiv.innerText || '';
  }

  /**
   * Downloads a plain text file containing logs.
   * It receives an array of formatted log strings, strips the HTML,
   * and triggers a download in the user's browser.
   * @param rawFormattedLogs Array of formatted log strings.
   * @param deviceId Identifier for the device (used in the file name).
   * @param defaultFileName Fallback name in case deviceId is not provided.
   */
  downloadLog(rawFormattedLogs: string[], deviceId: string | null, defaultFileName = 'tracker'): void {
    const content = rawFormattedLogs.map(line => this.stripHtml(line)).join('\n');
    const blob = new Blob([content], { type: 'text/plain;charset=utf-8' });

    const now = new Date();
    const nowFormatted = now.toLocaleString('fr-Fr');
    const fileName = `logs_${deviceId || defaultFileName}_${nowFormatted}.txt`;

    const a = document.createElement('a');
    a.href = URL.createObjectURL(blob);
    a.download = fileName;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  }
}
